import React, { useState, useEffect } from 'react';

const API = 'https://khepri.tech/api/v1';

function Brief() {
  const [data, setData] = useState(null);
  const [overdraftStatus, setOverdraftStatus] = useState('');
  const [demoRisk, setDemoRisk] = useState(false);
  const token = localStorage.getItem('khepri_token');

  useEffect(() => {
    fetch(API + '/khepri/brief', { headers: { Authorization: 'Bearer ' + token } })
      .then(r => r.json()).then(setData);
  }, []);

  const requestOverdraft = () => {
    setOverdraftStatus('pending');
    setTimeout(() => {
      setOverdraftStatus('approved');
    }, 2000);
  };

  const hasRisk = data?.has_risk || demoRisk;

  if (!data) return <p style={{color:'#94A3B8'}}>Loading...</p>;

  return (
    <div>
      {/* Переключатель демо */}
      <div style={{ marginBottom: 16, display: 'flex', justifyContent: 'flex-end' }}>
        <button
          onClick={() => { setDemoRisk(!demoRisk); setOverdraftStatus(''); }}
          style={{
            padding: '6px 14px',
            background: demoRisk ? '#EF4444' : '#334155',
            color: '#fff',
            border: 'none',
            borderRadius: 6,
            cursor: 'pointer',
            fontSize: 12,
            fontWeight: 600,
          }}
        >
          {demoRisk ? '🟢 Hide Demo' : '🔴 Demo: Cash Gap'}
        </button>
      </div>

      <div style={{ display: 'grid', gridTemplateColumns: 'repeat(3,1fr)', gap: 10, marginBottom: 20 }}>
        <div style={{ background: '#1E293B', padding: 14, borderRadius: 8, border: '1px solid #334155', textAlign: 'center' }}>
          <div style={{ fontSize: 10, color: '#94A3B8', textTransform: 'uppercase' }}>Balance</div>
          <div style={{ fontSize: 16, fontWeight: 700 }}>{(data.balance || 0).toLocaleString()} RUB</div>
        </div>
        <div style={{ background: '#1E293B', padding: 14, borderRadius: 8, border: '1px solid #334155', textAlign: 'center' }}>
          <div style={{ fontSize: 10, color: '#94A3B8', textTransform: 'uppercase' }}>Forecast</div>
          <div style={{ fontSize: 16, fontWeight: 700, color: hasRisk ? '#EF4444' : '#10B981' }}>{hasRisk ? 'RISK' : 'OK'}</div>
        </div>
        <div style={{ background: '#1E293B', padding: 14, borderRadius: 8, border: '1px solid #334155', textAlign: 'center' }}>
          <div style={{ fontSize: 10, color: '#94A3B8', textTransform: 'uppercase' }}>Next Payment</div>
          <div style={{ fontSize: 14, fontWeight: 700 }}>{(data.upcoming_tax_events || [])[0]?.name?.slice(0, 15) || 'None'}</div>
        </div>
      </div>

      {hasRisk && (
        <div style={{ marginBottom: 20, padding: 16, background: 'rgba(239,68,68,0.15)', border: '1px solid rgba(239,68,68,0.3)', borderRadius: 12 }}>
          <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', flexWrap: 'wrap', gap: 10 }}>
            <div>
              <strong style={{ color: '#EF4444' }}>⚠️ Cash gap detected!</strong>
              <p style={{ color: '#94A3B8', fontSize: 13, marginTop: 4 }}>
                Cash gap in 5 days. Balance will be −80 000 ₽. Consider overdraft protection.
              </p>
            </div>
            <button
              onClick={requestOverdraft}
              disabled={overdraftStatus === 'pending' || overdraftStatus === 'approved'}
              style={{
                padding: '10px 20px',
                background: overdraftStatus === 'approved' ? '#10B981' : overdraftStatus === 'pending' ? '#F59E0B' : '#6366F1',
                color: '#fff',
                border: 'none',
                borderRadius: 8,
                cursor: overdraftStatus === 'approved' ? 'default' : 'pointer',
                fontWeight: 600,
                whiteSpace: 'nowrap',
              }}
            >
              {overdraftStatus === 'approved' ? '✓ Overdraft Approved (200 000 ₽)' : overdraftStatus === 'pending' ? 'Processing...' : 'Request Overdraft'}
            </button>
          </div>
          {overdraftStatus === 'approved' && (
            <p style={{ color: '#10B981', fontSize: 13, marginTop: 8 }}>
              Sberbank pre-approved overdraft: 200 000 ₽ at 18% APR. Funds available in 5 minutes.
            </p>
          )}
          {overdraftStatus === '' && (
            <p style={{ color: '#94A3B8', fontSize: 11, marginTop: 8 }}>
              Credit concierge demo. Full integration with partner banks coming soon.
            </p>
          )}
        </div>
      )}

      <h3 style={{ marginBottom: 10 }}>Tasks</h3>
      {(data.tasks || []).map(t => (
        <div key={t.id} style={{ padding: 10, marginBottom: 6, background: '#1E293B', borderRadius: 8, borderLeft: '3px solid ' + (t.priority === 'critical' ? '#EF4444' : t.priority === 'high' ? '#F59E0B' : '#6366F1'), fontSize: 13 }}>
          {t.text}
        </div>
      ))}

      {(data.risks || []).length > 0 && (
        <div style={{ marginTop: 16, padding: 12, background: 'rgba(239,68,68,0.15)', borderRadius: 8, fontSize: 14 }}>
          {data.risks[0].description}
        </div>
      )}

      <h3 style={{ marginTop: 20, marginBottom: 10 }}>Forecast 14 days</h3>
      <table style={{ width: '100%', borderCollapse: 'collapse', fontSize: 12 }}>
        <thead><tr style={{ color: '#94A3B8' }}><th>Date</th><th>Balance</th><th>In</th><th>Out</th><th>Risk</th></tr></thead>
        <tbody>
          {(data.forecast_14d || []).slice(0, 14).map((p, i) => (
            <tr key={i} style={{ borderBottom: '1px solid #334155' }}>
              <td style={{ padding: 4 }}>{p.date?.slice(5)}</td>
              <td style={{ padding: 4, textAlign: 'right' }}>{Math.round(p.balance).toLocaleString()}</td>
              <td style={{ padding: 4, textAlign: 'right', color: '#10B981' }}>+{Math.round(p.income).toLocaleString()}</td>
              <td style={{ padding: 4, textAlign: 'right', color: '#EF4444' }}>-{Math.round(p.expense).toLocaleString()}</td>
              <td style={{ padding: 4, textAlign: 'center' }}>{p.risk === 'red' ? '🔴' : p.risk === 'yellow' ? '🟡' : '🟢'}</td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
}

export default Brief;